import { render, staticRenderFns } from "./PageITS.vue?vue&type=template&id=4e1f0f6c&scoped=true&"
import script from "./PageITS.vue?vue&type=script&lang=js&"
export * from "./PageITS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1f0f6c",
  null
  
)

export default component.exports